import {useRef, useState} from 'react'
import Dropzone, {DropEvent, DropzoneRef} from 'react-dropzone'
import {Button, Dimmer, Loader} from 'semantic-ui-react'

export interface IFileReaderProps {
  onFilesAccepted?: (files: File[], event: DropEvent) => void
}

export function FileReader(props: IFileReaderProps) {
  const {onFilesAccepted} = props

  const dropZoneRef = useRef<DropzoneRef>(null)

  const [isBusy, _setIsBusy] = useState(false)

  return (
    <div>
      <Dropzone
        ref={dropZoneRef}
        onDropAccepted={onFilesAccepted}
        noClick
        noKeyboard
      >
        {({getRootProps, getInputProps}) => {
          return (
            <div>
              <div {...getRootProps({className: 'dropzone'})}>
                <input {...getInputProps()} />
                <Button
                  compact
                  icon='file'
                  content='Open local file(s)'
                  onClick={() => {
                    if (dropZoneRef.current !== null) {
                      dropZoneRef.current.open()
                    }
                  }}
                  disabled={isBusy}
                />
              </div>
            </div>
          )
        }}
      </Dropzone>
      <Dimmer active={isBusy}>
        <Loader />
      </Dimmer>
    </div>
  )
}
